<template>
  <img alt="Ask Odds" class="logo mt-4 footer-logo" src="@/assets/logo.svg" />
</template>

<style scoped>
.footer-logo {
  width: auto;
  height: 5.5rem;
}
</style>

<script setup lang="ts"></script>
